const getBaseUrl = () =>
  window.location.protocol === 'https:'
    ? 'https://localhost:9101'
    : 'http://localhost:9100';

const getPrintersFromSdk = () =>
  new Promise((resolve, reject) => {
    window.BrowserPrint.getLocalDevices(
      (devices) => resolve(devices || []),
      reject,
      'printer'
    );
  });

const getPrintersFromLocalService = async () => {
  const response = await fetch(`${getBaseUrl()}/available`);
  if (!response.ok) {
    throw new Error('A Zebra Browser Print szolgáltatás nem érhető el.');
  }

  const devices = await response.json();
  return Array.isArray(devices?.printer) ? devices.printer : [];
};

export const getZebraPrinters = async () => {
  if (window.BrowserPrint?.getLocalDevices) {
    return getPrintersFromSdk();
  }

  return getPrintersFromLocalService();
};

export const sendZplToPrinter = (printer, zpl) => {
  if (printer?.send) {
    return new Promise((resolve, reject) => printer.send(zpl, resolve, reject));
  }

  return fetch(`${getBaseUrl()}/write`, {
    method: 'POST',
    body: JSON.stringify({
      device: {
        name: printer.name,
        uid: printer.uid,
        connection: printer.connection,
        deviceType: printer.deviceType,
        version: printer.version || 2,
        provider: printer.provider,
        manufacturer: printer.manufacturer
      },
      data: zpl
    })
  }).then((response) => {
    if (!response.ok) {
      throw new Error('A címke nem küldhető el a Zebra nyomtatóra.');
    }
  });
};
